<template>
  <div
    style="position: fixed; width: 100%; height: 100%; background: rgba(0, 0, 0, 0.9); z-index: 100"
  >
    <div
      class="iconfont"
      style="position: absolute; top: 200px; left: 20px; width: 100%; font-size: 50px"
    >
      <h1 style="color: white">{{ $t("langcfg.txtPowerOff") }}</h1>
    </div>
    <table>
      <tbody>
        <!-- <th colspan="2" style="text-align:left;padding-left:10px">{{$t('langcfg.txtShutdown')}}</th> -->
        <tr>
          <td v-if="isPoweringOff" colspan="2">
            <span style="color: white; font-size: 40px">{{ $t("langcfg.txtClosingDevice") }}</span>
            <br />
            <br />
          </td>
          <td v-if="!isPoweringOff">
            <div class="div-poweroff">
              <el-button @click="cancel" icon="el-icon-close" class="btn-oprator"></el-button>
              <!-- <br />
              <br />
              {{ $t('langcfg.txtCancel') }} -->
            </div>
          </td>
          <td v-if="!isPoweringOff">
            <div class="div-cancel">
              <el-button
                icon="el-icon-switch-button"
                type="primary"
                @click="powerOff"
                class="btn-oprator"
              ></el-button>
              <!-- <br />
              <br />
              <span> {{ $t('langcfg.txtPowerOff') }}</span> -->
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import fileSys from "../../../fileoprators/fileSystem";
export default {
  name: "PowerOff",
  components: {
    // IconButton
  },
  data() {
    return {
      isPoweringOff: false
    };
  },

  methods: {
    powerOff: function () {
      this.isPoweringOff = true;
      fileSys.powerOff();
    },
    cancel: function () {
      this.isPoweringOff = false;
      this.$emit("poweroff-cancel");
    }
  }
};
</script>

<style lang="less" scoped>
table,
tbody {
  width: 100%;
  height: 100%;
}
th {
  width: 800px;
  height: 10%;
  border: 2px gray solid;
}
tr {
  width: 800px;
  height: 80%;
  border: 2px gray solid;
  text-align: center;
  vertical-align: center;
}
td {
  width: 400px;
  height: 100%;
  text-align: center;
  vertical-align: center;
  color: white;
}
.el-button {
  width: 90%;
  margin-left: 5%;
  font-size: @header-fs;
  color: white;
  i {
    font-size: @header-fs+30px;
  }
}
.btn-oprator {
  height: @header-fs+110px;
  font-size: 100px;
}
.btn-oprator:hover {
  color: @btn-hover-color;
  i {
    color: @btn-hover-color;
  }
}
.btn-oprator:active {
  background: @btn-active-color;
}
.div-poweroff {
  margin-left: 45%;
  color: white;
  font-size: 30px;
}
.div-cancel {
  margin-right: 45%;
  color: white;
  font-size: 30px;
}
</style>



// WEBPACK FOOTER //
// src/mainInterface/components/settings/PowerOff.vue